export const agencies = [
  {
    id: 'immo-france-israel',
    name: 'ImmoFrance Israël',
    city: 'Tel Aviv',
    cities: ['Tel Aviv', 'Netanya', 'Herzliya'],
    languages: ['Français', 'Hébreu', 'Anglais'],
    specialties: ['Investissement locatif', 'Patrimonial', 'Airbnb'],
    description: "Agence spécialisée dans l'accompagnement des francophones à Tel Aviv et dans la région Centre. Plus de 200 transactions réalisées pour des investisseurs français.",
    contact: 'contact@immofrance-israel.com',
    phone: '+972 3 xxx xxxx',
    yearsActive: 12,
    transactionsCount: 200,
    rating: 4.8,
  },
  {
    id: 'netanya-homes',
    name: 'Netanya Homes',
    city: 'Netanya',
    cities: ['Netanya', 'Herzliya'],
    languages: ['Français', 'Hébreu'],
    specialties: ['Résidence principale', 'Investissement', 'Usage mixte'],
    description: 'Experts du marché de Netanya depuis 2008. Connaissance fine des quartiers francophones. Accompagnement de A à Z.',
    contact: 'info@netanyahomes.co.il',
    phone: '+972 9 xxx xxxx',
    yearsActive: 15,
    transactionsCount: 350,
    rating: 4.9,
  },
  {
    id: 'haifa-invest',
    name: 'Haïfa Invest',
    city: 'Haïfa',
    cities: ['Haïfa', 'Tirat Carmel', 'Nesher'],
    languages: ['Français', 'Hébreu', 'Russe'],
    specialties: ['Rendement', 'Étudiant', 'Long terme'],
    description: 'Spécialiste du marché haïfawi, en particulier le Carmel et Hadar. Forte expertise des biens à haut rendement.',
    contact: 'contact@haifainvest.co.il',
    phone: '+972 4 xxx xxxx',
    yearsActive: 9,
    transactionsCount: 140,
    rating: 4.7,
  },
  {
    id: 'jerusalem-premium',
    name: 'Jerusalem Premium Real Estate',
    city: 'Jérusalem',
    cities: ['Jérusalem'],
    languages: ['Français', 'Anglais', 'Hébreu'],
    specialties: ['Patrimonial', 'Diaspora', 'Airbnb'],
    description: 'Agence premium spécialisée dans les quartiers historiques et prisés de Jérusalem (Rechavia, German Colony, Baka). Interlocuteur privilégié de la diaspora.',
    contact: 'info@jerusalempremium.co.il',
    phone: '+972 2 xxx xxxx',
    yearsActive: 18,
    transactionsCount: 280,
    rating: 4.9,
  },
  {
    id: 'negev-invest',
    name: 'Néguev Invest',
    city: 'Beer Sheva',
    cities: ['Beer Sheva', 'Dimona', 'Arad'],
    languages: ['Français', 'Hébreu'],
    specialties: ['Premier investissement', 'Rendement élevé', 'Étudiant'],
    description: "Le spécialiste de l'investissement dans le Néguev. Tickets d'entrée accessibles, rendements élevés, connaissance du marché étudiant de la BGU.",
    contact: 'contact@negevinvest.co.il',
    phone: '+972 8 xxx xxxx',
    yearsActive: 7,
    transactionsCount: 95,
    rating: 4.6,
  },
  {
    id: 'eilat-vacation',
    name: 'Eilat Vacation Realty',
    city: 'Eilat',
    cities: ['Eilat'],
    languages: ['Français', 'Anglais', 'Hébreu'],
    specialties: ['Airbnb', 'Investissement touristique', 'Location saisonnière'],
    description: "Expert exclusif du marché d'Eilat. Stratégie Airbnb clé en main, gestion locative, optimisation des revenus touristiques.",
    contact: 'info@eilatvacationrealty.co.il',
    phone: '+972 8 xxx xxxx',
    yearsActive: 10,
    transactionsCount: 120,
    rating: 4.7,
  },
];

export const getAgenciesByCity = (cityName) => agencies.filter(a => a.cities.includes(cityName));
